import React, { useEffect, useState } from "react";
import {
  Typography,
  // TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import { withRouter, useHistory } from "react-router-dom";
import api from "../common/dependencies/utils/Api";
import hashImage from "../../assets/images/hashImage.jpeg";
import { connect } from "react-redux";
import Select, { components, DropdownIndicatorProps } from "react-select";
import Checkbox from "@mui/material/Checkbox";
import { Country, State, City } from "country-state-city";
import GlobalDropDown from "../common/GlobalDropDown";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";
import FileUpload from "../common/FileUpload";
import MultiselectorComp from "../MultiselectorComp/MultiselectorComp.js";
import SubmitForm from "../CohortForms/SubmitForm";
import {
  registerStartUp,
  savedraftStartUp,
  getViewApplicationData,
} from "./dependencies/action";
import { VIEW_STARTUP_APPLICATION_DATA } from "../common/constants/ApplicationUrl";

import FormValidator from "./FormValidator";
import InputField from "../common/InputField";
import TextareaField from "../common/TextAreaField";
// import { withStyles } from "@material-ui/core/styles";
import formbg from "../../assets/images/form-bg.jpg";
import LabelledOutline from "../common/LabelledOutline";
import { FileUploader } from "react-drag-drop-files";
import swal from "sweetalert";
import ImageUploading from "react-images-uploading";

import "./styles.scss";
import { getPredefineOptionsList } from "../BecomeMentorForms/dependencies/action";
import { toast } from "react-toastify";
// import { uploadFile, validateFile,submitEventRegistration } from '../dependencies/action';

const useStyles = makeStyles((theme) => ({
  rootSteps: {
    overflow: "hidden",
  },
  root: {
    //   "&.MuiPaper-root":{
    //     backgroundColor:"#fffafa" //as an Example
    // },

    "& $notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "&:hover $notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "&$focused $notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink ": {},
    "& .MuiFormLabel-root.MuiFocused": {
      transform: "translate(14px, -6px) scale(0.75);",
      color: "#ff0000",
      borderColor: "#5f6fc2 !important",
    },
    "&.MuiContainer-root": {
      color: "#000",
    },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
      transform: "translate(14px, -6px) scale(0.75);",
      // Default transform is "translate(14px, 20px) scale(1)""
      // This lines up the label with the initial cursor position in the input
      // after changing its padding-left.
      // transform: "translate(34px, 20px) scale(1);",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px !important",
    },
    "& .MuiInputBase-root": {
      margin: "10px !important",
      // height: "40px !important"
    },
    "& .MuiFilledInput-root": {
      backgroundColor: "#fff",
    },
    "& .MuiFilledInput-root:hover": {
      backgroundColor: "#fff",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#fff",
      },
    },
    " & .MuiStepIcon-root": {
      backgroundImage: "url",
      // backgroundImage: `url(data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e)`,
      // url("")
    },
    "& .input:focus": {
      borderColor: "#fff",
    },
    "& .MuiFilledInput-root.Mui-focused": {
      backgroundColor: "#fff",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      borderStyle: "hidden",
      color: "#e47d3f !important",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      borderStyle: "hidden",
      color: "#e47d3f !important",
    },
    "& MuiStepIcon-root.MuiStepIcon-active": {
      color: "#fff",
    },
    "& MuiFormLabel-root.Mui-focused": {
      color: "#fff",
    },
    "& .MuiFilledInput-underline:before": {
      borderBottom: "1px solid #c2bebe",
    },
    "& .MuiStepIcon-root": {
      borderStyle: "dotted",
      color: "#fff",
      borderColor: "#e47d3f",
      borderRadius: "14px",
    },
    "& .MuiStepIcon-text": {
      fill: "#000",
    },
    "& .MuiStepConnector-line": {
      borderColor: "#e47d3f",
      borderStyle: "dotted",
    },
  },
  inputRoot: {
    color: "purple",
    // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
    // '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
    //   // Default left padding is 6px
    //   paddingLeft: 26
    // },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "& .MuiInputBase-input": {
      height: "30px !important",
      fontSize: "16px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f4f4f4",
    },
    "& .MuiStepIcon-root": {
      borderStyle: "dotted",
      color: "#000",
      // borderRadius: "10px"
    },
    "& .MuiPaper-root": {
      borderRadius: "100px",
      backgroundColor: "##ff", //as an Example
      boxShadow: "10px 10px 5px 0px rgba(0,0,0,0.75);",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px !important",
      borderTopLeftRadius: "10px ",
      borderTopRightRadius: "10px",
    },
  },
  leftbutton: {
    marginRight: theme.spacing(1),
    backgroundColor: "#3AC2D7",
    color: "#fff",
    width: "150px",
  },
  rightbutton: {
    marginRight: theme.spacing(1),
    backgroundColor: "#f4f4f4",
    border: "1 solid #000",
    width: "150px",
  },

  button: {
    backgroundColor: "#e47d3f",
  },
  // root: {
  //   "& .MuiFilledInput-root": {
  //     background: "rgb(232, 241, 250)"
  //   }
  // }
}));

const genders = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },

  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Prefer not to disclose",
    label: "Prefer not to disclose",
  },
];

const customStyles = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "16px",
  }),
};

const StartupSteps = (props) => {
  // alert(props.fromModule)
  const prefilledGenderObject = {
    value: props.location.state && props.location.state.gender,
    label: props.location.state && props.location.state.gender,
  };

  const prefilledStateObject = {
    value: props.location.state && props.location.state.state,

    label: props.location.state && props.location.state.state,
  };
  const prefilledCityObject = {
    value: props.location.state && props.location.state.city,

    label: props.location.state && props.location.state.city,
  };

  const newCountryArray = [];
  const newStateArray = [];
  const hiddenFileInput = React.useRef(null);
  const { registerStartUp, savedraftStartUp } = props;
  const history = useHistory();
  const [servicedata, setServiceData] = useState();
  // const [state, setState] = useState("");
  // const [preferedsector, setPreferedSector] = useState([]);
  const [alreadySelectedState, stateAlreadySelectedState] = useState(
    props.location.state && props.location.state.state
  );
  // const [preferedfuncsupport, setPreferedFuncSupport] = useState([]);
  // const [startupstage, setStartupStage] = useState([]);
  // const [removefileButton, setRemoveFileButton] = useState(false);
  const [uploadedFileEvent, setUploadedFileEvent] = useState([]);
  const [filesEvent, setFilesEvent] = useState([]);
  const [showSubmitCohort, setShowSubmitCohort] = useState(false);
  const [submitFormData, setSubmitFormData] = useState({});
  const [profileExistingImg, setProfileExistingImg] = useState();
  const [applicationStatusValue, setApplicationStatusValue] = useState();
  // const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [prefilledState, setPrefilledState] = useState(prefilledStateObject);
  // const [prefilledStage, setPrefilledStage] = useState();
  // prefilledCurrentStageObject
  const [prefilledCity, setPrefilledCity] = useState(
    prefilledCityObject

    // props.location.state.city
  );
  const [genderfocused, setGenderFocused] = useState(false);
  const [statefocused, setStateFocused] = useState(false);
  const [cityfocused, setCityFocused] = useState(false);

  const [prefilledGender, setPrefilledGender] = useState(prefilledGenderObject);

  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCityOptions, setNewCityOptions] = useState([]);
  // const [stageList, setStageList] = useState(null);
  // const [specializationList, setSpecializationList] = useState(null);
  // const [functionList, setFunctionList] = useState(null);
  // const [industrySectorList, setIndustrySectorList] = useState(null);
  // const [industryList, setIndustryList] = useState(null);
  const { getPredefineOptionsList, getPredefineOptions } = props;
  const [getPredefinedContent, setGetPredefinedContent] = useState("");
  // const [viewApplicationData, setViewApplicationData] = useState();
  const [userId, setUserId] = useState("");
  const [newSelectedState, setNewSelectedState] = useState("");

  const [discussonSummary, setDiscussonSummary] = useState("");
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter Services Offered by Startup"
  );
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [wordLimit, setWordlimit] = useState();

  const [wordCounter2, setWordCounter2] = useState(0);
  const [errorMessagePurpose2, setErrorMessagePurpose2] = useState(
    "*Please Enter Problem Solved by Startup"
  );
  const [errorVisible8, SetErrorVisible8] = useState(false);
  const [wordLimit2, setWordlimit2] = useState();

  const [wordCounter3, setWordCounter3] = useState(0);
  const [errorMessagePurpose3, setErrorMessagePurpose3] = useState(
    "*Please Enter Why You Need Mentorship"
  );
  const [errorVisible9, SetErrorVisible9] = useState(false);
  const [wordLimit3, setWordlimit3] = useState();

  const [wordCounter4, setWordCounter4] = useState(0);
  const [errorMessagePurpose4, setErrorMessagePurpose4] = useState(
    "*Please Enter Expected Outcomes from Mentorship Sessions"
  );
  const [errorVisible10, SetErrorVisible10] = useState(false);
  const [wordLimit4, setWordlimit4] = useState();

  // const [draftData, setDraftData] = useState("");

  const input = document.getElementById("offered_startup");

  useEffect(() => {
    if (props.location.state && props.location.state.services) {
      let servicedata2 = props.location.state.services;

      servicedata2 = servicedata2.filter(function (item) {
        return item != "";
      });

      if (servicedata2.length == 0) {
        servicedata2 = "NA";
      }
      setServiceData(servicedata2);
    } else {
      setServiceData("NA");
    }
  }, []);
  useEffect(() => {
    // const input = document.getElementById("offered_startup");
    // const end = input.value.length;

    // input.setSelectionRange(end, end);

    const loginDataJson = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // alert(props.location.state.applicationStatus);
    const newId = loginDataJson.id;

    setUserId(newId);
    const test = getPredefineOptionsList();

    // alert("test " + loginDataJson.applicationStatus);
    const params = { id: props.location.state?.dippNumber };
    api
      .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data) {
            const responseData = response.data.data;
            setApplicationStatusValue(responseData.applicationStatus);
            if (responseData.applicationStatus === "SUBMITTED") {
              if (props.fromModule && props.fromModule === "editProfile") {
                setNewSelectedState(responseData.state);
                newStateOptionfunc(responseData.state);
                const industryDataDraft = [];
                const subIndustryDraft = [];
                const functionDraft = [];
                const subspecializationDraft = [];
                const currentstageDraft = [];

                setFormData((user) => {
                  responseData?.industrydata?.map((item) => {
                    const industryObject = {
                      value: item,
                      label: item,
                    };
                    industryDataDraft.push(industryObject);
                  });

                  responseData?.subindustry?.map((item) => {
                    const subindustryObject = {
                      value: item != null ? item : "",
                      label: item != null ? item : "",
                    };
                    subIndustryDraft.push(subindustryObject);
                  });

                  responseData?.preffered_function?.map((item) => {
                    const functionObject = {
                      value: item,
                      label: item,
                    };
                    functionDraft.push(functionObject);
                  });

                  responseData?.subspecialization?.map((item) => {
                    const subfunctionObject = {
                      value: item,
                      label: item,
                    };
                    subspecializationDraft.push(subfunctionObject);
                  });

                  responseData?.preffered_stages?.map((item) => {
                    const currentstageObject = {
                      value: item,
                      label: item,
                    };
                    currentstageDraft.push(currentstageObject);
                  });

                  return {
                    ...user,
                    designation: responseData.designation,
                    AppLindin_url: responseData.appLindin_url,
                    state_name: responseData.state_name,
                    state:
                      responseData.state === ""
                        ? ""
                        : {
                            value: responseData.state,
                            label: responseData.state_name
                              ? responseData.state_name
                              : responseData.state,

                            // label: responseData.state_name ? responseData.state_name : responseData.state_name,
                          },
                    gender: {
                      value: responseData.gender,
                      label: responseData.gender,
                    },
                    city:
                      responseData.city === ""
                        ? ""
                        : {
                            value: responseData.city,
                            label: responseData.city,
                          },
                    // city: responseData.city,
                    // AppLindin_url: responseData.appLindin_url,
                    startupwebsite: responseData.startupwebsite,
                    startup_video_url: responseData.startup_video_url,
                    current_revenue: responseData.curret_revenue,
                    offered_startup: responseData.offered_startup,
                    problem_solved: responseData.problem_solved,
                    whyneedMentorship: responseData.whyneedMentorship,
                    expected_outcome: responseData.expected_outcome,
                    contact_no: responseData.contact_no,
                    industrydata: industryDataDraft,
                    subindustry: subIndustryDraft,
                    preferedfuncsupport: functionDraft,
                    subspecialization: subspecializationDraft,
                    uploadLogo: responseData.uploadLogo,
                    currentstage: currentstageDraft,
                    uploadLogoFromUrl:
                      // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                      responseData.upload_logo,
                    uploadProfile: responseData.upload_profile,
                    uploadProfileFromUrl:
                      // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                      responseData.upload_profile,
                    upload_document: responseData.upload_document,
                    uploadDocFromUrl:
                      // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                      responseData.upload_document,
                  };
                });
              } else {
                let value = localStorage.getItem("SavedLoggedInData");
                let LoginFormData = JSON.parse(value);
                history.push({
                  pathname: "/startup-dashboard",
                  state: LoginFormData,
                });
              }
            } else {
              setNewSelectedState(responseData.state);
              newStateOptionfunc(responseData.state);
              const industryDataDraft = [];
              const subIndustryDraft = [];
              const functionDraft = [];
              const subspecializationDraft = [];
              const currentstageDraft = [];

              setFormData((user) => {
                responseData?.industrydata?.map((item) => {
                  const industryObject = {
                    value: item,
                    label: item,
                  };
                  industryDataDraft.push(industryObject);
                });

                responseData?.subindustry?.map((item) => {
                  const subindustryObject = {
                    value: item != null ? item : "",
                    label: item != null ? item : "",
                  };
                  subIndustryDraft.push(subindustryObject);
                });

                responseData?.preffered_function?.map((item) => {
                  const functionObject = {
                    value: item,
                    label: item,
                  };
                  functionDraft.push(functionObject);
                });

                responseData?.subspecialization?.map((item) => {
                  const subfunctionObject = {
                    value: item,
                    label: item,
                  };
                  subspecializationDraft.push(subfunctionObject);
                });

                responseData?.preffered_stages?.map((item) => {
                  const currentstageObject = {
                    value: item,
                    label: item,
                  };
                  currentstageDraft.push(currentstageObject);
                });

                return {
                  ...user,
                  designation: responseData.designation,
                  AppLindin_url: responseData.appLindin_url,
                  state_name: responseData.state_name,
                  state:
                    responseData.state === ""
                      ? ""
                      : {
                          value: responseData.state,
                          label: responseData.state_name
                            ? responseData.state_name
                            : responseData.state,
                          // label: responseData.state_name ? responseData.state_name : responseData.state_name,
                        },
                  gender: {
                    value: responseData.gender,
                    label: responseData.gender,
                  },
                  city:
                    responseData.city === ""
                      ? ""
                      : {
                          value: responseData.city,
                          label: responseData.city,
                        },
                  // city: responseData.city,
                  // AppLindin_url: responseData.appLindin_url,
                  startupwebsite: responseData.startupwebsite,
                  startup_video_url: responseData.startup_video_url,
                  current_revenue: responseData.curret_revenue,
                  offered_startup: responseData.offered_startup,
                  problem_solved: responseData.problem_solved,
                  whyneedMentorship: responseData.whyneedMentorship,
                  expected_outcome: responseData.expected_outcome,
                  contact_no: responseData.contact_no,
                  industrydata: industryDataDraft,
                  subindustry: subIndustryDraft,
                  preferedfuncsupport: functionDraft,
                  subspecialization: subspecializationDraft,
                  uploadLogo: responseData.uploadLogo,
                  currentstage: currentstageDraft,
                  uploadLogoFromUrl:
                    // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                    responseData.upload_logo,
                  uploadProfile: responseData.upload_profile,
                  uploadProfileFromUrl:
                    // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                    responseData.upload_profile,
                  upload_document: responseData.upload_document,
                  uploadDocFromUrl:
                    // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                    responseData.upload_document,
                };
              });
            }
          }

          // setViewApplicationData(response.data.data);
        } else {
        }
      })
      .catch((e) => {});

    // if (
    //   props.location.state &&
    //   props.location.state.applicationStatus === "SUBMITTED"
    // ) {
    //
    // } else {
    //
    //   const params = { id: props.location.state?.dippNumber };
    //   api
    //     .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, params)
    //     .then((response) => {
    //       const { data, status } = response || {};
    //       if (status === 200) {
    //
    //         if (response.data.data) {
    //           const responseData = response.data.data;
    //           setFormData((user) => {
    //             const industryDataDraft = [];
    //             const subIndustryDraft = [];
    //             const functionDraft = [];
    //             const subspecializationDraft = [];

    //             responseData.industrydata.map((item) => {
    //               const industryObject = {
    //                 value: item,
    //                 label: item,
    //               };
    //               industryDataDraft.push(industryObject);
    //             });

    //             responseData.subindustry.map((item) => {
    //               const subindustryObject = {
    //                 value: item,
    //                 label: item,
    //               };
    //               subIndustryDraft.push(subindustryObject);
    //             });

    //             responseData.preffered_function.map((item) => {
    //               const functionObject = {
    //                 value: item,
    //                 label: item,
    //               };
    //               functionDraft.push(functionObject);
    //             });

    //             responseData.subspecialization.map((item) => {
    //               const subfunctionObject = {
    //                 value: item,
    //                 label: item,
    //               };
    //               subspecializationDraft.push(subfunctionObject);
    //             });

    //

    //             return {
    //               ...user,
    //               designation: responseData.designation,
    //               appLindin_url: responseData.appLindin_url,
    //               state_name: responseData.state_name,
    //               state:
    //                 responseData.state === ""
    //                   ? ""
    //                   : {
    //                       value: responseData.state,
    //                       label: responseData.state,
    //                     },
    //               gender: {
    //                 value: responseData.gender,
    //                 label: responseData.gender,
    //               },
    //               startupwebsite: responseData.startupwebsite,
    //               startup_video_url: responseData.startup_video_url,
    //               curret_revenue: responseData.curret_revenue,
    //               offered_startup: responseData.offered_startup,
    //               problem_solved: responseData.problem_solved,
    //               whyneedMentorship: responseData.whyneedMentorship,
    //               expected_outcome: responseData.expected_outcome,
    //               contact_no: responseData.contact_no,
    //               industrydata: industryDataDraft,
    //               subindustry: subIndustryDraft,
    //               preferedfuncsupport: functionDraft,
    //               subspecialization: subspecializationDraft,
    //             };
    //           });
    //         }

    //         setViewApplicationData(response.data.data);
    //       } else {
    //       }
    //     })
    //     .catch((e) => {});
    // }
    // calling view applicaiton service
  }, []);
  useEffect(() => {
    const dropdownList = getPredefineOptions?.industry_options.shift();
    const dropdownList2 = getPredefineOptions?.functional_areas.shift();
    const dropdownList4 = getPredefineOptions?.sub_industry.shift();
    const dropdownList5 = getPredefineOptions?._specialisation.shift();
    setGetPredefinedContent(getPredefineOptions);
  }, [getPredefineOptions]);
  const [phonevalue, setPhoneValue] = useState(
    props.location.state && "91" + props.location.state.phone
  );
  const [selectedCountry, setSelectedCountry] = useState(
    props.location.state.state === ""
      ? props.location.state && props.location.state.country.toLowerCase()
      : "in"
  );

  const onclickShowSubmitCohort = (Id) => {
    // setActivityFellowId(Id);
    setShowSubmitCohort(true);
  };

  const clickOnClose = () => {
    setShowSubmitCohort((x) => !x);
    // getActivityFellow()
  };
  const [error, setError] = useState({});
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const fileTypes = ["JPG", "PNG", "GIF"];

  const renderErrorMessage = (name) => {
    return (
      <div style={{ paddingLeft: "0px" }}>
        <div className="login-error-msg">{name}</div>
      </div>
    );
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    props.handleFile(fileUploaded);
  };

  const customStylesCountry = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    // menu:provided=>({
    //   ...provided,
    //   zIndex: 9999
    // }),
    menuPortal: (provided) => ({ ...provided, zIndex: 999999999 }),
    menu: (provided) => ({ ...provided, zIndex: 999999999 }),
    container: (provided, state) => ({
      ...provided,
      marginTop: 40,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      overflow: "visible",
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top:
        state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused
          ? "-120%"
          : "0%",
      transition: "top 0.2s, font-size 0.2s",
      fontSize:
        (state.hasValue ||
          state.selectProps.inputValue ||
          state.selectProps.isFocused) &&
        14,
      marginLeft:
        (state.hasValue ||
          state.selectProps.inputValue ||
          state.selectProps.isFocused) &&
        -10,
    }),
  };

  function getSteps() {
    return [
      "STARTUP DETAILS",

      "APPLICANT DETAILS",

      "STARTUP SUMMARY",

      "STARTUP SERVICES",

      "MENTORSHIP DETAILS",

      props.fromModule && props.fromModule === "editProfile"
        ? "DISCLAIMER"
        : "MENTORSHIP REQUIREMENTS",

      // "UPLOAD DOCUMENT",<
    ];
  }
  const dynamicArray = [
    {
      step1: {
        name: "Entity Details",
        fields: [
          {
            id: "entitiyname",
            name: "Entitiy Name",
            field_Type: "textbox",
            className: "",
          },
          {
            name: "entitiyname",
          },
          {
            name: "entitiyname",
          },
        ],
      },
    },

    {
      step2: {
        "Entity Details": {},
      },
    },

    {
      step3: {
        "Entity Details": {},
      },
    },
  ];

  const [file, setFile] = useState(null);
  const handleChangeFile = (file) => {
    setFile(file);
  };

  const validateStep1Input = () => {
    const { entity_name, applicant_name, dpiit_no } = formData;
    const formStatus = FormValidator.validateStep1({
      entity_name,
      applicant_name,
      dpiit_no,
    });

    const errors = {
      entityName: formStatus.entityName,
      applicant_name: formStatus.applicant_name,
      dpiitNo: formStatus.dpiitNo,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };
  const validateStep2Input = () => {
    const {
      email_id,
      contact_no,
      designation,
      gender,
      state,
      city,
      city_name,
    } = formData;
    const country = "India";
    const formStatus = FormValidator.validateStep2({
      email_id,
      contact_no,
      designation,
      gender,
      country,
      state,
      city,
    });
    const errors = {
      email_id: formStatus.email_id,
      contact_no: formStatus.contact_no,
      designation: formStatus.designation,
      gender: formStatus.gender,
      country: formStatus.country,
      state: formStatus.state,
      city: formStatus.city,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };
  const validateStep3Input = () => {
    const {
      AppLindin_url,
      startupwebsite,
      startup_video_url,
      current_revenue,
    } = formData;
    const formStatus = FormValidator.validateStep3({
      AppLindin_url,
      startupwebsite,
      startup_video_url,
      current_revenue,
    });

    const errors = {
      AppLindin_url: formStatus.AppLindin_url,
      startupwebsite: formStatus.startupwebsite,
      startup_video_url: formStatus.startup_video_url,
      current_revenue: formStatus.current_revenue,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };
  const validateStep4Input = () => {
    const { offered_startup, problem_solved } = formData;
    const formStatus = FormValidator.validateStep4({
      offered_startup,
      problem_solved,
    });

    const errors = {
      offeredstartupStatus: formStatus.offeredstartupStatus,
      problemsolvedStatus: formStatus.problemsolvedStatus,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };

  const validateStep5Input = () => {
    const { whyneedMentorship, expected_outcome } = formData;
    const formStatus = FormValidator.validateStep5({
      whyneedMentorship,
      expected_outcome,
    });

    const errors = {
      whyneedMentorshipStatus: formStatus.whyneedMentorshipStatus,
      expectedoutcomeStatus: formStatus.expectedoutcomeStatus,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFormData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
    if (fileType === "removePath") {
      setFormData((user) => {
        return { ...user, ["uploadDocFromUrl"]: null };
      });
    }
  };
  const validateStep6Input = () => {
    const {
      // sector,
      industrydata,
      // preferedsectormentor,
      subindustry,
      preferedfuncsupport,
      subspecialization,
      currentstage,
      disclaimer,
      // preferredStage,
    } = formData;
    const formStatus = FormValidator.validateStep6({
      // sector,
      // preferedsectormentor,
      industrydata,
      subindustry,
      preferedfuncsupport,
      subspecialization,
      currentstage,
      disclaimer,
      // preferredStage,
    });

    const errors = {
      sector: formStatus.sector,
      // preferedsectormentor: formStatus.preferedsectormentor,
      industrydata: formStatus.industrydata,
      subindustry: formStatus.subindustry,
      preferedfuncsupport: formStatus.preferedfuncsupport,
      subspecialization: formStatus.subspecialization,
      currentstage: formStatus.currentstage,
      disclaimer: formStatus.disclaimer,
      // preferredStage: formStatus.preferredStage,
    };
    setError(errors);

    return !formStatus.hasErrors;
  };
  // const validateStep7Input = () => {
  //   const {   } = formData;
  //   const formStatus = FormValidator.validateStep7({

  //   });

  //   const errors = {

  //   };
  //
  //   setError(errors);
  //   return !formStatus.hasErrors;
  // };
  const previewProfilePic = (file) => {
    if (FileReader) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          document.getElementById("fileUpload-profile-pic").src = image.src;
        };
      };
    }
  };
  const previewProfilePic1 = (file) => {
    if (FileReader) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          document.getElementById("fileUpload-profile").src = image.src;
        };
      };
    }
  };
  const onBlur = () => {
    // if (activeStep === 0) validateStep1Input();
    if (activeStep === 1) validateStep2Input();
    if (activeStep === 2) validateStep3Input();
    if (activeStep === 3) validateStep4Input();
    if (activeStep === 4) validateStep5Input();
    if (activeStep === 5) validateStep6Input();
    // if (activeStep === 6) validateStep7Input();
  };
  const onUploadFile = (file, name) => {
    const onUploadFile = (file, name) => {
      // frame.src=URL.createObjectURL(event.target.files[0]);
      // const dataValue = new FormData();
      // dataValue.append("campaign", file);
      // validateFile(dataValue).then(res => {
      //     if(res){
      //           if (uploadedFileEvent.length < 3) {
      //         const data = new FormData();
      //         data.append("file", file);
      //         // uploadFile(data).then(res => {
      //         //     if (res?.status) {
      //         //         setFilesEvent([...filesEvent, res?.filename]);
      //         //         setUploadedFileEvent([...uploadedFileEvent, {attachfile:res?.attachfile}])
      //         //     } else {
      //         //         toast.error("something went wrong");
      //         //     }
      //         // })
      //     } else {
      //         toast.error("You can upload maximum 3 files only");
      //     }
      //     }
      // })
    };

    const removeFile = (file, type) => {
      let index = filesEvent.indexOf(file);
      if (index > -1) {
        uploadedFileEvent.splice(index, 1);
        filesEvent.splice(index, 1);
        setFilesEvent([...filesEvent]);
        setUploadedFileEvent([...uploadedFileEvent]);
      }
    };
  };
  const oncheckedChange = (e) => {
    setFormData((user) => {
      return { ...user, disclaimer: !formData.disclaimer };
    });
  };
  const getStepContent = (
    activeStep,
    classes,
    // autoFetchedData,
    contentList
  ) => {
    const oncheckedChange = (e) => {
      setFormData((user) => {
        return { ...user, disclaimer: !formData.disclaimer };
      });
      validateStep6Input();
    };

    const testWordLimit = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value > 100) {
        setErrorMessagePurpose(""); //Exceeds word limit reached");
        SetErrorVisible7(true);
      } else if (value < 100 && value > 0) {
        SetErrorVisible7(false);
        setErrorMessagePurpose("*Please Enter Services Offered by Startup");
      } else if (value == 0) {
        SetErrorVisible7(true);
        document.getElementById("offered_startup").value = "";
      } else if (value == 101) {
        setWordCounter(100);
        return value;
      }
      setWordCounter(value);
      return value;
    };

    const testWordLimit2 = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value == 100) {
        setErrorMessagePurpose2("Exceeds word limit reached");
        SetErrorVisible8(true);
      } else if (value < 100 && value > 0) {
        SetErrorVisible8(false);
        setErrorMessagePurpose2("*Please Enter Problem Solved by Startup");
      } else if (value == 0) {
        SetErrorVisible8(true);
        document.getElementById("problem_solved").value = "";
      } else if (value == 101) {
        setWordCounter2(100);
        return value;
      }
      setWordCounter2(value);
      return value;
    };

    const testWordLimit3 = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value > 100) {
        setErrorMessagePurpose3(""); //Exceeds word limit reached");
        SetErrorVisible9(true);
      } else if (value < 100 && value > 0) {
        SetErrorVisible9(false);
        setErrorMessagePurpose3("*Please Enter Why You Need Mentorship");
      } else if (value == 0) {
        SetErrorVisible9(true);
        document.getElementById("whyneedMentorship").value = "";
      } else if (value == 101) {
        setWordCounter3(100);
        return value;
      }
      setWordCounter3(value);
      return value;
    };

    const testWordLimit4 = (data) => {
      let value =
        data?.length === 0
          ? 0
          : data
              ?.replace(/(^\s*)|(\s*$)/gi, "")
              ?.replace(/[ ]{2,}/gi, " ")
              ?.split(" ")?.length;
      if (value > 100) {
        setErrorMessagePurpose4(""); //Exceeds word limit reached");
        SetErrorVisible10(true);
      } else if (value < 100 && value > 0) {
        SetErrorVisible10(false);
        setErrorMessagePurpose4(
          "*Please Enter Expected Outcomes from Mentorship Sessions"
        );
      } else if (value == 0) {
        SetErrorVisible10(true);
        document.getElementById("expected_outcome").value = "";
      } else if (value == 101) {
        setWordCounter4(100);
        return value;
      }
      setWordCounter4(value);
      return value;
    };

    const handleInputChange = (e) => {
      // alert(e.target.name)

      try {
        if (e.target.name === "uploadResume") {
          let file = e.target.files[0];
          if (e.target.files[0].type == "application/pdf") {
            const fileSize = file.size / 1024 / 1024; // in MB
            if (fileSize > 2) {
              toast.error("File size exceeds 2 MB");
            } else {
              setFormData((user) => {
                return { ...user, [e.target.name]: e.target.files[0] };
              });
            }
          } else {
            toast.error("File format is not supported");
          }
        } else if (e.target.name === "uploadLogo") {
          if (
            e.target.files[0].type == "image/png" ||
            e.target.files[0].type == "image/jpeg"
          ) {
            let file = e.target.files[0];

            const fileSize = file.size / 1000; // 500 kb
            if (fileSize > 500) {
              toast.error("File size exceeds 500 KB");
            } else {
              // validateStep1Input();
              previewProfilePic(e.target.files[0]);
              setFormData((user) => {
                return { ...user, [e.target.name]: e.target.files[0] };
              });
            }
          } else {
            toast.error("File format is not supported");
          }
        } else if (e.target.name === "uploadProfile") {
          if (
            e.target.files[0].type == "image/png" ||
            e.target.files[0].type == "image/jpeg"
          ) {
            let file = e.target.files[0];

            const fileSize = file.size / 1000; // 500 kb
            if (fileSize > 500) {
              toast.error("File size exceeds 500 KB");
            } else {
              // validateStep1Input();
              previewProfilePic1(e.target.files[0]);
              setFormData((user) => {
                return { ...user, [e.target.name]: e.target.files[0] };
              });
            }
          } else {
            toast.error("File format is not supported");
          }
        } else {
          const { value, name } = e.target;

          setFormData((user) => {
            return { ...user, [name]: value };
          });
        }
        // if (e.target.name === "uploadResume") {
        //   setFormData((user) => {
        //     return { ...user, [e.target.name]: e.target.files[0] };
        //   });
        // } else if (e.target.name === "uploadLogo") {
        //   setFormData((user) => {
        //     return { ...user, [e.target.name]: e.target.files[0] };
        //   });
        // } else {
        //   const { value, name } = e.target;

        //   setFormData((user) => {
        //     return { ...user, [name]: value };
        //   });
        // }
      } catch (error) {}
      // const { value, name } = e.target;
      // // alert(value)
      // setFormData((user) => {
      //   return { ...user, [name]: value };
      // });
    };

    const maxNumber = 1;

    // alert(formData.entity_name)
    // const classes = useStyles();
    // alert(contentList && contentList.length)

    const { ValueContainer, Placeholder } = components;

    const CustomValueContainer = ({ children, ...props }) => {
      return (
        <ValueContainer {...props}>
          <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
          </Placeholder>
          {React.Children.map(children, (child) =>
            child && child.key !== "placeholder" ? child : null
          )}
        </ValueContainer>
      );
    };

    switch (activeStep) {
      case 0:
        return (
          <>
            <div className="startupstepsforms">
              <InputField
                required={true}
                id="entity_name"
                label="Entity Name"
                disabled
                variant="outlined"
                placeholder="Type Here.."
                fullWidth
                margin="normal"
                onChange={handleInputChange}
                value={formData.entity_name}
                name="entity_name"
                error={error.entityName}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {/* {error.entityName && renderErrorMessage(error.entityName)} */}

              <div className="file_upload">
                <div>
                  <div className="rowC ">
                    <div className="col-md-9">
                      <p
                        class="upload-mentor-text"
                        style={{ paddingLeft: "4px" }}
                      >
                        UPLOAD LOGO (OPTIONAL)
                      </p>
                      <p style={{ textAlign: "left" }}>
                        <br />
                        <span
                          className="supported-file "
                          style={{ paddingLeft: "11px", position: "inherit" }}
                        >
                          <div className="startupformText">
                            <div>{`Supported file format jpeg,png.`}</div>
                            <div>{`Only upto 500KB`}</div>
                          </div>
                        </span>
                      </p>
                    </div>
                    <img
                      className="col-md-3 responsiveStartupLogo"
                      id="fileUpload-profile-pic"
                      // src={
                      //   // formData.uploadLogo &&
                      //   formData.uploadLogoFromUrl
                      //     ? formData.uploadLogoFromUrl
                      //     : formData.uploadLogo
                      //     ? previewProfilePic(formData && formData.uploadLogo)
                      //     : profileExistingImg
                      // }
                      // src={
                      //   formData.uploadLogo
                      //     ? formData.uploadLogo
                      //     : formData.uploadProfile
                      //     ? previewProfilePic1(formData && formData.uploadProfile)
                      //     : hashImage
                      // }
                      src={
                        formData.uploadLogo !== null &&
                        formData.uploadLogo !== "" &&
                        formData.uploadLogo !== undefined
                          ? previewProfilePic(formData && formData.uploadLogo)
                          : formData.uploadLogoFromUrl !== null &&
                            formData.uploadLogoFromUrl !== "" &&
                            formData.uploadLogoFromUrl !== undefined
                          ? formData.uploadLogoFromUrl
                          : hashImage
                      }
                      // style={{
                      //   width: "100px",
                      //   marginLeft: "15px",
                      //   marginTop: "5px",
                      //   height: "60px",
                      // }}
                    />
                  </div>

                  <input
                    className="file-upload11"
                    type="file"
                    // name="Upload Document"
                    id="fileUpload-logo"
                    name="uploadLogo"
                    // accept="image/*"
                    accept="image/png, image/jpeg"
                    // accept="application/pdf, application/vnd.ms-excel"
                    onChange={handleInputChange}
                    onBlur={onBlur}
                    // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                  />
                </div>
              </div>
              {/* <InputField
                required={true}
                id="applicant_name"
                disabled
                label="Applicant Name"
                onChange={handleInputChange}
                variant="outlined"
                placeholder="Type Here.."
                fullWidth
                margin="normal"
                value={formData.applicant_name}
                // value={autoFetchedData.applicant_name}
                name="applicant_name"
                error={error.applicant_name}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              /> */}
              {/* <div className="file_upload">
                <div>
                  <div className="rowC ">
                    <div className="col-md-9">
                      <p
                        class="upload-mentor-text"
                        style={{ paddingLeft: "11px" }}
                      >
                        UPLOAD PROFILE (OPTIONAL)
                      </p>
                      <p style={{ textAlign: "left" }}>
                        <br />
                        <span
                          className="supported-file"
                          style={{ paddingLeft: "11px", position: "inherit" }}
                        >
                          Supported file format jpeg, png only upto 500KB
                        </span>
                      </p>
                    </div>
                    <img
                      className="col-md-3"
                      id="fileUpload-profile"
                      hidden={
                        !formData.uploadProfile
                         
                      }
                      src={
                        formData.uploadProfile
                          ? previewProfilePic1(formData && formData.uploadProfile)
                          :""
                      }
                      style={{
                        width: "100px",
                        marginLeft: "15px",
                        marginTop: "5px",
                        height: "60px",
                      }}
                    />
                  </div>

                  <input
                    className="file-upload"
                    type="file"
                    // name="Upload Document"
                    id="uploadProfile"
                    name="uploadProfile"
                    // accept="image/*"
                    accept="image/png, image/jpeg"
                    // accept="application/pdf, application/vnd.ms-excel"
                    onChange={handleInputChange}
                    onBlur={onBlur}
                    // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                  />
                </div>
              </div> */}
              <InputField
                required={true}
                id="dpiit_no"
                label="DPIIT Number"
                disabled
                onChange={handleInputChange}
                variant="outlined"
                placeholder="Type Here.."
                fullWidth
                // value={autoFetchedData.name&&autoFetchedData.dippNumber}
                value={formData.dpiit_no}
                // value={formData.dippNumber}
                margin="normal"
                name="dpiit_no"
                error={error.dpiitNo}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              <InputField
                required={true}
                id="sector"
                disabled
                label="Sector"
                variant="outlined"
                placeholder="Type Here...."
                onChange={(e, name) => handleInputChange(e, name)}
                // onChange={handleInputChange()}
                fullWidth
                margin="normal"
                // value={autoFetchedData.sectors &&autoFetchedData.sectors[0]}
                value={formData.sector}
                name="sector"
                // error={error.sector}
                onBlur={onBlur}
                // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {/* {error.sector && renderErrorMessage(error.sector)} */}
              <InputField
                required={true}
                disabled
                id="industry"
                label="Industry"
                variant="outlined"
                placeholder="Type Here.."
                onChange={handleInputChange}
                // value={autoFetchedData.industry&&autoFetchedData.industry}
                fullWidth
                margin="normal"
                value={formData.industry}
                name="industry"
                // error={error.industry}
                onBlur={onBlur}
                // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {/* {error.industry && renderErrorMessage(error.industry)} */}
              <InputField
                required={true}
                disabled
                id="function"
                label="Function"
                variant="outlined"
                placeholder="Type Here.."
                onChange={handleInputChange}
                // value={autoFetchedData.industry&&autoFetchedData.industry}
                fullWidth
                margin="normal"
                value={servicedata && servicedata}
                name="function"
                // error={error.industry}
                onBlur={onBlur}
                // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              <InputField
                required={true}
                id="stage"
                label="Stage"
                disabled
                variant="outlined"
                placeholder="Type Here.."
                onChange={handleInputChange}
                fullWidth
                // value={autoFetchedData.stage&&autoFetchedData.stage}
                margin="normal"
                value={formData.stage}
                name="stage"
                // error={error.stage}
                onBlur={onBlur}
                // hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
            </div>
          </>
        );

      case 1:
        return (
          <div className="startupstepsforms">
            <InputField
              required={true}
              id="applicant_name"
              // disabled
              label="Applicant Name"
              onChange={handleInputChange}
              variant="outlined"
              placeholder="Type Here.."
              fullWidth
              margin="normal"
              value={formData.applicant_name}
              // value={autoFetchedData.applicant_name}
              name="applicant_name"
              error={error.applicant_name}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            <div className="file_upload">
              <div>
                <div className="rowC ">
                  <div className="col-md-9">
                    <p
                      class="upload-mentor-text uploadProfilePhotoWidth"
                      // style={{ paddingLeft: "11px" }}
                    >
                      UPLOAD PROFILE PHOTO (OPTIONAL)
                    </p>
                    <p style={{ textAlign: "left" }}>
                      <br />
                      <span
                        className="supported-file"
                        style={{ paddingLeft: "11px", position: "inherit" }}
                      >
                        {/* Supported file format jpeg, png only upto 500KB */}
                        <div className="startupformText2">
                          <div>{`Supported file format jpeg,png.`}</div>
                          <div>{`Only upto 500KB`}</div>
                        </div>
                      </span>
                    </p>
                  </div>
                  <img
                    className="col-md-3"
                    id="fileUpload-profile"
                    // src={
                    //   formData.uploadProfileFromUrl
                    //     ? formData.uploadProfileFromUrl
                    //     : formData.uploadProfile
                    //     ? previewProfilePic1(formData && formData.uploadProfile)
                    //     : hashImage
                    // }
                    // src={
                    //   formData.uploadProfileFromUrl
                    //     ? formData.uploadProfileFromUrl
                    //     : formData.uploadProfile
                    //     ? previewProfilePic1(formData && formData.uploadProfile)
                    //     : ""
                    // }
                    src={
                      formData.uploadProfile?.name !== null &&
                      formData.uploadProfile?.name !== "" &&
                      formData.uploadProfile?.name !== undefined
                        ? previewProfilePic1(formData && formData.uploadProfile)
                        : formData.uploadProfileFromUrl !== null &&
                          formData.uploadProfileFromUrl !== "" &&
                          formData.uploadProfileFromUrl !== undefined
                        ? formData.uploadProfileFromUrl
                        : hashImage
                    }
                    // hidden={!formData.uploadProfile}
                    // src={
                    //   formData.uploadProfileFromUrl
                    //     ? formData.uploadProfileFromUrl
                    //     : formData.uploadProfile
                    //     ? previewProfilePic1(formData && formData.uploadProfile)
                    //     : ""
                    // }
                    style={{
                      width: "100px",
                      marginLeft: "0px",
                      marginTop: "5px",
                      height: "60px",
                    }}
                  />
                </div>

                <input
                  className="file-upload"
                  type="file"
                  // name="Upload Document"
                  id="uploadProfile"
                  name="uploadProfile"
                  // accept="image/*"
                  accept="image/png, image/jpeg"
                  // accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleInputChange}
                  onBlur={onBlur}
                  // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                />
              </div>
            </div>
            <InputField
              required={true}
              id="email_id"
              disabled
              label="Email Id"
              variant="outlined"
              placeholder="Type Here.."
              fullWidth
              onChange={handleInputChange}
              margin="normal"
              value={formData.email_id}
              name="email_id"
              error={error.email_id}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {/* <div
            className="row"
           
          > */}

            {/* <div
                  className="col-md-6 col-sm-12"
               
                >
            <InputField
                  required={true}
                  id="designation"
                  label="Designation"
                  variant="outlined"
                  placeholder="Type Here.."
                  fullWidth
                  margin="normal"
                  onChange={handleInputChange}
                  value={formData.designation}
                  name="designation"
                  error={error.designation}
                  onBlur={onBlur}
                  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                />
                </div> */}
            {/* <div
                className="col-md-6 col-sm-12"
             style={{paddingTop:"5px"}}
              > */}

            <PhoneInput
              // country={selectedCountry}
              country={"in"}
              onlyCountries={["in"]}
              placeholder="+91 9999999999"
              value={formData.contact_no}
              style={{ fontSize: "16px" }}
              countryCodeEditable={false}
              onChange={(phonevalue, country) => {
                // const phoneCountryObject = {
                //   value: country.countryCode.toUpperCase(),

                //   label: country.name,
                // };

                setFormData((user) => {
                  return {
                    ...user,
                    contact_no: phonevalue,
                  };
                });

                // setFormData((user) => {
                //   return { ...user, phonevalue };
                // });

                setSelectedCountry(country.countryCode);
                // setPhoneValue(phonevalue);
              }}
              // error={error.contact_no}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {error.contact_no && renderErrorMessage(error.contact_no)}
            {/* </div>  
              </div> */}

            <InputField
              required={true}
              id="designation"
              label="Designation"
              variant="outlined"
              placeholder="Type Here.."
              fullWidth
              margin="normal"
              onChange={handleInputChange}
              value={formData.designation}
              name="designation"
              error={error.designation}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />

            <Select
              required={true}
              id="gender"
              // label="Gender*"
              variant="outlined"
              fullWidth
              margin="normal"
              name="gender"
              className="col-12 genderstartupinput"
              // styles={customStyles}
              styles={customStylesCountry}
              value={formData.gender}
              // defaultValue={genderOption}
              // onChange={handleInputChange}
              onChange={(e) => {
                // setGender(e.value);

                setFormData((user) => {
                  return { ...user, gender: e };
                });
              }}
              maxMenuHeight={300}
              onFocus={() => setGenderFocused(true)}
              onBlur={() => setGenderFocused(false)}
              isFocused={genderfocused}
              // placeholder="My Cool Label and work Focused"
              // isClearable
              components={{
                ValueContainer: CustomValueContainer,
              }}
              options={genders}
              // please dont remove/delete this onblur below,otherwise you wont be able to edit this input

              // onBlur={onBlur}
              placeholder="Gender*"
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {error.gender && renderErrorMessage(error.gender)}

            <InputField
              required={true}
              disabled
              fullWidth
              id="country"
              label="Country"
              variant="outlined"
              placeholder="Type Here.."
              margin="normal"
              // onChange={handleInputChange}
              value="India"
              name="Country"
              error={error.Country}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {/* {error.designation && renderErrorMessage(error.designation)} */}

            {/* {formData.country === "IN" ? ( */}
            <div
              className="row"
              style={{
                // margin: "auto",
                marginLeft: "0px",
                paddingLeft: "0px",
                paddingRight: "0px",
                marginBottom: "5px",
              }}
            >
              <div
                className="col-md-6 col-sm-12"
                style={{ paddingLeft: "0px" }}
              >
                <Select
                  required={true}
                  id="state"
                  // label="Gender*"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="State"
                  name="state"
                  placeholder="State*"
                  className="col-12 countrystartupinput"
                  // styles={customStyles}
                  styles={customStylesCountry}
                  value={formData.state}
                  onChange={(e) => {
                    setFormData((user) => {
                      return { ...user, city: "" };
                    });
                    setFormData((user) => {
                      return { ...user, city_name: "" };
                    });
                    setFormData((user) => {
                      return { ...user, state: e };
                    });
                    setFormData((user) => {
                      return { ...user, state_name: e.label };
                    });
                    newStateOptionfunc(e.value);
                    stateAlreadySelectedState(e.value);
                  }}
                  maxMenuHeight={300}
                  onFocus={() => setStateFocused(true)}
                  onBlur={() => setStateFocused(false)}
                  isFocused={statefocused}
                  // placeholder="My Cool Label and work Focused"
                  // isClearable
                  components={{
                    ValueContainer: CustomValueContainer,
                  }}
                  options={newStateOptions}
                  // options={Country.getAllCountries()}

                  // please dont remove/delete this onblur below,otherwise you wont be able to edit this input
                  // onBlur={onBlur}
                  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                  // disabled={props.location.state.state !== "" ? true : false}
                />
                {error.state && renderErrorMessage(error.state)}

                {/* <InputField
              required={true}
              id="state"
              disabled
              label="State"
              variant="outlined"
              placeholder="Type Here.."
              fullWidth
              onChange={handleInputChange}
              margin="normal"
              value={formData.state}
              name="state"
              error={error.state}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            /> */}
                {/* {error.state && renderErrorMessage(error.state)} */}
              </div>
              <div
                className="col-md-6 col-sm-12"
                style={{ paddingLeft: "0px", zIndex: "1" }}
              >
                {/* <InputField
              required={true}
              id="city"
              disabled
              label="City"
              variant="outlined"
              placeholder="Type Here.."
              fullWidth
              onChange={handleInputChange}
              margin="normal"
              value={formData.city}
              name="state"
              error={error.city}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            /> */}
                <Select
                  required={true}
                  id="city"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="City"
                  name="city"
                  placeholder="City*"
                  className="col-12 countrystartupinput"
                  // styles={customStyles}
                  styles={customStylesCountry}
                  value={formData.city}
                  onChange={(e) => {
                    localStorage.setItem("startupcity", e.value);
                    setFormData((user) => {
                      return { ...user, city: e };
                    });
                    setFormData((user) => {
                      return { ...user, city_name: e.label };
                    });
                  }}
                  maxMenuHeight={300}
                  onFocus={() => setCityFocused(true)}
                  onBlur={() => setCityFocused(false)}
                  isFocused={cityfocused}
                  // placeholder="My Cool Label and work Focused"
                  // isClearable
                  components={{
                    ValueContainer: CustomValueContainer,
                  }}
                  options={newCityOptions}
                  // please dont remove/delete this onblur below,otherwise you wont be able to edit this input

                  // onBlur={onBlur}
                  // placeholder={
                  //   props.location.state.city !== ""
                  //     ? props.location.state.city
                  //     : "City*"
                  // }
                  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                />
                {error.city && renderErrorMessage(error.city)}
              </div>
            </div>
            {/* ) : (
              <InputField
                required={true}
                id="city"
                label="City"
                variant="outlined"
                placeholder="Enter City"
                fullWidth
                margin="normal"
                marginTop="5px"
                name="city"
                onChange={handleInputChange}
                value={formData.city}
                error={error.city}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              // {error.city && renderErrorMessage(error.city)}
            )} */}
          </div>
        );

      case 2:
        return (
          <div className="startupstepsforms">
            <h6 className="question-heading homepageSecondDescription">
              Applicant LinkedIn URL
            </h6>
            <InputField
              id="AppLindin_url"
              // label="Applicant LinkedIN URL"
              variant="outlined"
              onChange={handleInputChange}
              placeholder="Type Here URL (e.g. prefix with http:// or https://)"
              fullWidth
              margin="normal"
              value={formData.AppLindin_url}
              name="AppLindin_url"
              error={error.AppLindin_url}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />

            <h6 className="question-heading homepageSecondDescription">
              Startup Website
            </h6>
            <InputField
              // required={true}
              id="startupwebsite"
              onChange={handleInputChange}
              // label="Startup Website"
              variant="outlined"
              placeholder="Type Here URL (e.g. prefix with http:// or https://)"
              fullWidth
              margin="normal"
              value={formData.startupwebsite}
              name="startupwebsite"
              error={error.startupwebsite}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            <h6 className="question-heading homepageSecondDescription">
              Startup or Product Video URL
            </h6>
            <InputField
              id="startup_video_url"
              onChange={handleInputChange}
              // label="Startup or Product Video URL "
              variant="outlined"
              placeholder="Type Here URL (e.g. prefix with http:// or https://)"
              fullWidth
              margin="normal"
              value={formData.startup_video_url}
              name="startup_video_url"
              error={error.startup_video_url}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            <div className="file_upload" style={{ marginTop: "12px" }}>
              <div>
                <p class="upload-mentor-text">
                  Upload Startup Deck or other Documents{" "}
                </p>
                <p
                  style={{
                    textAlign: "left",
                    paddingLeft: "10px",
                    fontSize: "16px",
                  }}
                >
                  <br />
                  <span style={{ paddingLeft: "13px" }}>
                    Supported file format PDF only upto 2MB
                  </span>
                </p>
                <div className="fileupload-resume-startup">
                  <input
                    className="resume-upload"
                    type="file"
                    id="fileUpload-resume"
                    required
                    name="uploadResume"
                    onChange={handleInputChange}
                    accept="application/pdf"
                    onBlur={onBlur}
                  />
                </div>
              </div>
            </div>

            {formData.uploadResume && formData.uploadResume.name !== null ? (
              <div style={{ marginBottom: "50px" }}>
                <div className="file-name" style={{ float: "left" }}>
                  {formData.uploadResume.name}{" "}
                  <span
                    style={{ marginLeft: "10px" }}
                    onClick={() => removeFile("uploadResume")}
                  >
                    {" "}
                    X
                  </span>
                </div>
              </div>
            ) : formData?.uploadDocFromUrl &&
              formData?.uploadDocFromUrl !== null ? (
              <div className="file-name">
                {formData.uploadDocFromUrl &&
                  formData.uploadDocFromUrl.split("/").pop()}
                <span
                  style={{ marginLeft: "10px" }}
                  onClick={() => removeFile("removePath")}
                >
                  {" "}
                  X{" "}
                </span>
              </div>
            ) : (
              formData.uploadResume && (
                <div className="file-name">
                  {formData.uploadResume &&
                    formData.uploadResume.split("/").pop()}
                  <span
                    style={{ marginLeft: "10px" }}
                    onClick={() => removeFile("uploadResume")}
                  >
                    {" "}
                  </span>
                </div>
              )
            )}
            <div>
              <h6 className="question-heading homepageSecondDescription">
                Current Revenue in INR (Pro Rata)
              </h6>
              <InputField
                // required={true}
                id="current_revenue"
                onChange={handleInputChange}
                // label="Current Revenue Pro Rata"
                variant="outlined"
                placeholder="Type Here.."
                type="number"
                fullWidth
                margin="normal"
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                value={formData.current_revenue}
                name="current_revenue"
                error={error.current_revenue}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
              />
            </div>
          </div>
        );

      case 3:
        return (
          <div className="startupstepsforms">
            <h6 className="question-heading homepageSecondDescription">
              Core Services Offered by Startup (max 100 words) *
            </h6>
            <TextareaField
              required={true}
              id="offered_startup"
              // className="textarea"
              // onChange={handleInputChange}
              variant="outlined"
              placeholder={"Describe in maximum 100 words"}
              fullWidth
              margin="normal"
              value={formData.offered_startup}
              name="offered_startup"
              onChange={(e, name) => {
                // if (testWordLimit(e.target.value) < 100) {
                //   handleInputChange(e, name);
                // }
                const value = e.target.value;
                const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                const newerData = newData.replace(/[ ]{2,}/gi, " ");
                if (
                  // newerData.split(" ").length <= 101 &&
                  testWordLimit(newerData) < 101
                ) {
                  handleInputChange(e, name);
                } else {
                  // alert("test")
                  const datvalue = newerData
                    .split(/\s+/)
                    .slice(0, 100)
                    .join(" ");
                  if (formData.offered_startup.split(" ")?.length < 100)
                    setFormData((user) => {
                      return { ...user, ["offered_startup"]: datvalue };
                    });
                }

                setWordlimit(newerData);
              }}
              // multiline
              rows={2}
              maxRows={4}
              // error={error.offeredstartupStatus}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {/* <div className="wordCounter">Word Count: {wordCounter} / 100</div> */}
            <div
              className="wordCounter"
              style={{ fontWeight: "bold", textAlign: "right" }}
            >
              Word Count:{" "}
              {formData.offered_startup?.length === 0
                ? 0
                : wordLimit?.length === 0
                ? 0
                : formData.offered_startup
                    ?.replace(/(^\s*)|(\s*$)/gi, "")
                    ?.replace(/[ ]{2,}/gi, " ")
                    ?.split(" ")?.length}{" "}
              / 100
            </div>
            {
              // error.offeredstartupStatus
              //   ? renderErrorMessage(error.offeredstartupStatus)

              //   :
              error.offeredstartupStatus
                ? renderErrorMessage(errorMessagePurpose)
                : ""
            }
            {/* {errorVisible7 && (
                <div className="login-error-msg mt-2">{errorMessagePurpose}</div>
              )} */}
            <h6 className="question-heading homepageSecondDescription">
              The Problem Being Solved by Startup (max 100 words) *
            </h6>
            <TextareaField
              required={true}
              id="problem_solved"
              className="textArea"
              // onChange={handleInputChange}

              onChange={(e, name) => {
                // if (testWordLimit(e.target.value) < 100) {
                //   handleInputChange(e, name);
                // }
                const value = e.target.value;
                const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                const newerData = newData.replace(/[ ]{2,}/gi, " ");
                if (
                  // newerData.split(" ").length <= 101 &&
                  testWordLimit2(newerData) < 101
                ) {
                  handleInputChange(e, name);
                } else {
                  const datvalue = newerData
                    .split(/\s+/)
                    .slice(0, 100)
                    .join(" ");
                  if (formData.problem_solved.split(" ")?.length < 100)
                    setFormData((user) => {
                      return { ...user, ["problem_solved"]: datvalue };
                    });
                }

                setWordlimit2(newerData);
              }}
              // label="The Problem Being Solved By Startup"
              variant="outlined"
              placeholder="Describe in maximum 100 words"
              fullWidth
              margin="normal"
              value={formData.problem_solved}
              name="problem_solved"
              // multiline
              rows={2}
              maxRows={4}
              // error={error.problemsolvedStatus}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            <div
              className="wordCounter"
              style={{ fontWeight: "bold", textAlign: "right" }}
            >
              Word Count:{" "}
              {formData.problem_solved?.length === 0
                ? 0
                : wordLimit2?.length === 0
                ? 0
                : formData.problem_solved
                    ?.replace(/(^\s*)|(\s*$)/gi, "")
                    ?.replace(/[ ]{2,}/gi, " ")
                    ?.split(" ")?.length}{" "}
              / 100
            </div>
            {error.problemsolvedStatus
              ? renderErrorMessage(errorMessagePurpose2)
              : ""}
            {/* {error.problemsolvedStatus &&
                renderErrorMessage(error.problemsolvedStatus)} */}
          </div>
        );
      case 4:
        return (
          <div className="startupstepsforms">
            <h6 className="question-heading homepageSecondDescription">
              Why Do You Need Mentorship? (max 100 words) *{" "}
            </h6>
            <TextareaField
              required={true}
              id="whyneedMentorship"
              // onChange={handleInputChange}

              onChange={(e, name) => {
                // if (testWordLimit(e.target.value) < 100) {
                //   handleInputChange(e, name);
                // }
                const value = e.target.value;
                const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                const newerData = newData.replace(/[ ]{2,}/gi, " ");
                if (
                  // newerData.split(" ").length <= 101 &&
                  testWordLimit3(newerData) < 101
                ) {
                  handleInputChange(e, name);
                } else {
                  const datvalue = newerData
                    .split(/\s+/)
                    .slice(0, 100)
                    .join(" ");
                  if (formData.whyneedMentorship.split(" ")?.length < 100)
                    setFormData((user) => {
                      return { ...user, ["whyneedMentorship"]: datvalue };
                    });
                }

                setWordlimit3(newerData);
              }}
              // label="Why Do You Need Mentorship ?"
              variant="outlined"
              placeholder="Describe in maximum 100 words"
              fullWidth
              margin="normal"
              value={formData.whyneedMentorship}
              name="whyneedMentorship"
              // multiline
              rows={2}
              maxRows={4}
              // error={error.whyneedMentorshipStatus}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />

            <div
              className="wordCounter"
              style={{ fontWeight: "bold", textAlign: "right" }}
            >
              Word Count:{" "}
              {formData.whyneedMentorship?.length === 0
                ? 0
                : wordLimit3?.length === 0
                ? 0
                : formData.whyneedMentorship
                    ?.replace(/(^\s*)|(\s*$)/gi, "")
                    ?.replace(/[ ]{2,}/gi, " ")
                    ?.split(" ")?.length}{" "}
              / 100
            </div>
            {error.whyneedMentorshipStatus
              ? renderErrorMessage(errorMessagePurpose3)
              : ""}

            {/* {error.whyneedMentorshipStatus &&
              renderErrorMessage(error.whyneedMentorshipStatus)} */}
            <h6 className="question-heading homepageSecondDescription">
              What are Your Expected Outcomes from Mentorship Sessions? (max 100
              words) *
            </h6>
            <TextareaField
              required={true}
              id="expected_outcome"
              // onChange={handleInputChange}
              onChange={(e, name) => {
                // if (testWordLimit(e.target.value) < 100) {
                //   handleInputChange(e, name);
                // }
                const value = e.target.value;
                const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                const newerData = newData.replace(/[ ]{2,}/gi, " ");
                if (
                  // newerData.split(" ").length <= 101 &&
                  testWordLimit4(newerData) < 101
                ) {
                  handleInputChange(e, name);
                } else {
                  const datvalue = newerData
                    .split(/\s+/)
                    .slice(0, 100)
                    .join(" ");
                  if (formData.expected_outcome.split(" ")?.length < 100)
                    setFormData((user) => {
                      return { ...user, ["expected_outcome"]: datvalue };
                    });
                }

                setWordlimit4(newerData);
              }}
              // label="What Are Your Expected Outcomes From Mentorship Sessions?"
              variant="outlined"
              placeholder="Describe in maximum 100 words"
              fullWidth
              margin="normal"
              value={formData.expected_outcome}
              name="expected_outcome"
              // multiline
              rows={2}
              maxRows={4}
              // error={error.expectedoutcomeStatus}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            <div
              className="wordCounter"
              style={{ fontWeight: "bold", textAlign: "right" }}
            >
              Word Count:{" "}
              {formData.expected_outcome?.length === 0
                ? 0
                : wordLimit4?.length === 0
                ? 0
                : formData.expected_outcome
                    ?.replace(/(^\s*)|(\s*$)/gi, "")
                    ?.replace(/[ ]{2,}/gi, " ")
                    ?.split(" ")?.length}{" "}
              / 100
            </div>
            {error.expectedoutcomeStatus
              ? renderErrorMessage(errorMessagePurpose4)
              : ""}

            {/* {error.expectedoutcomeStatus &&
              renderErrorMessage(error.expectedoutcomeStatus)} */}

            <div></div>
          </div>
        );
      case 5:
        return (
          <div className="startupstepsforms" style={{ paddingBottom: "10px" }}>
            {props.fromModule && props.fromModule === "editProfile" ? (
              ""
            ) : (
              <h4> First Mentorship Requirement</h4>
            )}
            {/* <h6>Sector of Startup*</h6>
          <InputField
              required={true}
              id="sector"
              // label="Sector"
              variant="outlined"
              placeholder="Type Here...."
              onChange={handleInputChange}
              // onChange={handleInputChange()}
              fullWidth
              margin="normal"
              // value={autoFetchedData.sectors &&autoFetchedData.sectors[0]}
              value={formData.sector}
              name="sector"
              error={error.sector}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              disabled={formData.sector !== "" ? true : false}
            /> */}
            {props.fromModule && props.fromModule === "editProfile" ? (
              ""
            ) : (
              <div>
                <span
                  class="d-inline-block multiselectorspan"
                  data-toggle="popover"
                  data-trigger="focus"
                  data-content="Please selecet account(s)"
                >
                  {" "}
                  <h6>Industry (Select 1 Industry) *</h6>
                  {/* <InputField
                required={true}
                id="industry"
                // label="Industry"
                // disabled
                variant="outlined"
                placeholder="Type Here.."
                onChange={handleInputChange}
                // value={autoFetchedData.industry&&autoFetchedData.industry}
                fullWidth
                margin="normal"
                value={formData.industry}
                name="industry"
                error={error.industry}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                isDisabled={industryList === "" ? false : true}
              /> */}
                  <MultiselectorComp
                    // options={subIndustryOptions}
                    isDisabled={
                      props.fromModule && props.fromModule === "editProfile"
                        ? true
                        : false
                    }
                    options={
                      getPredefineOptions &&
                      getPredefineOptions.industry_options
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    // placeholder="Industry"
                    // placeholder={
                    //   formData.industry === "" ? "Industry" : formData?.industry
                    // }
                    styles={customStyles} //setIndustry(v)
                    onChange={(list) =>
                      list.length < 2
                        ? setFormData((user) => {
                            let arr = list.filter(function (item) {
                              return item.value !== "select";
                            });
                            if (list.length === 2) {
                              swal({
                                title: "Info!",
                                text: "Maximum limit 1 Reached for Industry",
                                icon: "info",
                              });
                            }
                            return { ...user, industrydata: arr };
                          })
                        : swal({
                            title: "Info!",
                            text: "Maximum limit 1 Reached for Industry",
                            icon: "info",
                          })
                    }
                    // value={formData.industry}
                    value={formData.industrydata}
                    // onBlur={onBlur}
                    // isDisabled={industryList === "" ? false : true}
                  />
                </span>
                {error.industrydata && renderErrorMessage(error.industrydata)}

                <span
                  class="d-inline-block multiselectorspan"
                  data-toggle="popover"
                  data-trigger="focus"
                  data-content="Please selecet account(s)"
                >
                  <div
                    className={
                      formData.subspecialization.length === 10
                        ? "top-btn tooltipicon"
                        : ""
                    }
                  >
                    <h6>
                      Industry / Sector - Keywords (Industry/Function Keywords
                      Select up to 10 Combined) *{" "}
                    </h6>
                    <MultiselectorComp
                      isDisabled={
                        props.fromModule && props.fromModule === "editProfile"
                          ? true
                          : formData.subspecialization.length === 10
                          ? true
                          : false
                      }
                      // options={subIndustryOptions}
                      options={
                        getPredefineOptions && getPredefineOptions.sub_industry
                      }
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Industry / Sector"
                      styles={customStyles} //setIndustry(v)
                      // error={error.subindustry}
                      onChange={(list) =>
                        list.length <= 10 - formData.subspecialization.length
                          ? setFormData((user) => {
                              let arr = list.filter(function (item) {
                                return item.value !== "select";
                              });
                              if (
                                list.length +
                                  formData.subspecialization.length ==
                                10
                              ) {
                                swal({
                                  title: "Info!",
                                  text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                                  icon: "info",
                                });
                              }
                              return { ...user, subindustry: arr };
                            })
                          : swal({
                              title: "Info!",
                              text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                              icon: "info",
                            })
                      }
                      // onChange={(list) =>
                      //   list.length < 6
                      //     ? setFormData((user) => {
                      //         return { ...user, subindustry: list };
                      //       })
                      //     : null
                      // }
                      value={formData.subindustry}
                      // isDisabled={industrySectorList.length === 0 ? false : true}
                      // onBlur={onBlur}
                    />
                    <span
                      className={
                        formData.subspecialization.length === 10
                          ? "tooltiptext4"
                          : "d-none"
                      }
                    >
                      Can not add more than 10 keywords
                    </span>
                  </div>
                </span>

                {error.subindustry && renderErrorMessage(error.subindustry)}

                <span
                  class="d-inline-block multiselectorspan"
                  data-toggle="popover"
                  data-trigger="focus"
                  data-content="Please selecet account(s)"
                  style={{ paddingTop: "10px" }}
                >
                  <h6>Function (Select 1 Function) *</h6>
                  <MultiselectorComp
                    isDisabled={
                      props.fromModule && props.fromModule === "editProfile"
                        ? true
                        : false
                    }
                    // options={supportFunctions}
                    options={
                      getPredefineOptions && getPredefineOptions._specialisation
                    }
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder=" Select Prefered Function of Support"
                    styles={customStyles} //setIndustry(v)
                    // error={error.preferedfuncsupport}
                    onChange={(list) =>
                      list.length < 2
                        ? setFormData((user) => {
                            let arr = list.filter(function (item) {
                              return item.value !== "select";
                            });
                            if (list.length === 2) {
                              swal({
                                title: "Info!",
                                text: "Maximum limit 1 Reached for Function",
                                icon: "info",
                              });
                            }
                            return { ...user, preferedfuncsupport: arr };
                          })
                        : swal({
                            title: "Info!",
                            text: "Maximum limit 1 Reached for Function",
                            icon: "info",
                          })
                    }
                    value={formData.preferedfuncsupport}
                    // onBlur={onBlur}
                    // isDisabled={functionList.length === 0 ? false : true}
                  />
                </span>
                {error.preferedfuncsupport &&
                  renderErrorMessage(error.preferedfuncsupport)}
                <span
                  class="d-inline-block multiselectorspan"
                  data-toggle="popover"
                  data-trigger="focus"
                  data-content="Please selecet account(s)"
                >
                  <div
                    className={
                      formData.subindustry.length === 10
                        ? "top-btn tooltipicon"
                        : ""
                    }
                  >
                    <h6
                      className={
                        formData.subindustry.length === 10
                          ? "industryDisabled"
                          : ""
                      }
                    ></h6>
                    <h6>
                      Function - Keywords (Industry/Function Keywords Select up
                      to 10 Combined) *
                    </h6>
                    <MultiselectorComp
                      isDisabled={
                        props.fromModule && props.fromModule === "editProfile"
                          ? true
                          : formData.subindustry.length === 10
                          ? true
                          : false
                      }
                      // options={subSpecializationOptions }
                      options={
                        getPredefineOptions &&
                        getPredefineOptions.functional_areas
                      }
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Function"
                      styles={customStyles}
                      // error={error.subspecialization}
                      // onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                      onChange={(list) =>
                        list.length < 11 - formData.subindustry.length
                          ? setFormData((user) => {
                              let arr = list.filter(function (item) {
                                return item.value !== "select";
                              });
                              if (
                                list.length + formData.subindustry.length ==
                                10
                              ) {
                                swal({
                                  title: "Info!",
                                  text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                                  icon: "info",
                                });
                              }
                              return { ...user, subspecialization: arr };
                            })
                          : swal({
                              title: "Info!",
                              text: "Maximum limit 10 Reached for Industry and Function Keywords combined",
                              icon: "info",
                            })
                      }
                      // onChange={(list) =>
                      //   list.length < 6
                      //     ? setFormData((user) => {
                      //         return { ...user, subspecialization: list };
                      //       })
                      //     : null
                      // }
                      value={formData.subspecialization}
                      // onBlur={onBlur}
                      // isDisabled={specializationList.length === 0 ? false : true}
                    />
                    <span
                      className={
                        formData.subindustry.length === 10
                          ? "tooltiptext4"
                          : "d-none"
                      }
                    >
                      Can not add more than 10 keywords
                    </span>
                  </div>
                </span>
                {error.subspecialization &&
                  renderErrorMessage(error.subspecialization)}

                <h6>Current Stage of the Startup (Select 1 Stage) *</h6>
                {/* <InputField
                required={true}
                id="stage"
                // label="Stage"
                disabled
                variant="outlined"
                placeholder="Type Here.."
                onChange={handleInputChange}
                fullWidth
                // value={autoFetchedData.stage&&autoFetchedData.stage}
                margin="normal"
                value={formData.stage}
                name="stage"
                error={error.stage}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              /> */}
                <MultiselectorComp
                  isDisabled={
                    props.fromModule && props.fromModule === "editProfile"
                      ? true
                      : false
                  }
                  // options={stagecurrent}
                  options={
                    getPredefineOptions &&
                    getPredefineOptions.stage_of_startup_options
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  // placeholder=" Select Preferred Stage Of the Startup"
                  // error={error.preferredStage}
                  styles={customStyles} //setIndustry(v)
                  // onChange={(list) =>
                  //   setFormData((user) => {
                  //     let arr = list.filter(function (item) {
                  //       return item.value !== "*" && item.value !== "select";
                  //     });
                  //     return { ...user, currentstage: arr };
                  //   })
                  // }
                  onChange={(list) =>
                    list.length < 2
                      ? setFormData((user) => {
                          let arr = list.filter(function (item) {
                            if (list.length === 2) {
                              swal({
                                title: "Info!",
                                text: "Maximum limit 1 Reached for Current Stage ",
                                icon: "info",
                              });
                            }
                            return item.value !== "select";
                          });
                          return { ...user, currentstage: arr };
                        })
                      : swal({
                          title: "Info!",
                          text: "Maximum limit 1 Reached for Current Stage ",
                          icon: "info",
                        })
                  }
                  // allowSelectAll={true}
                  value={formData.currentstage}
                  // onBlur={onBlur}
                />
                {error.currentstage && renderErrorMessage(error.currentstage)}
                {/* <MultiselectorComp
                options={
                  getPredefineOptions &&
                  getPredefineOptions.stage_of_startup_options
                }
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                // placeholder={
                //   formData.stage === ""
                //     ? "Preferred stage of the startup"
                //     : formData?.stage
                // }       
                styles={customStyles}
//  onChange={(list) =>
//                   list.length < 2
//                     ? setFormData((user) => {
//                         let arr = list.filter(function (item) {
//                      
//                           return item.value !== "select";
//                         });
//                         return { ...user, industrydata: arr };
//                       })
//                     : null
//                 }

                onChange={ formData.currentstage === "" ? (list) =>
                  setFormData((user) => {
                    let arr = list.filter(function (item) {
                     
                      return item.value !== "*" && item.value !== "select";
                    });
                    return { ...user, currentstage: arr };
                  }) : ""
                }
                allowSelectAll={true}
                onBlur={onBlur}
                value={formData.currentstage}
                // isDisabled={stageList.length === 0 ? false : true}
                /> */}
              </div>
            )}
            <div className="disclaimerMaindiv startupdisclaimermaindiv">
              {/* <input
                type="checkbox"
                
                // defaultChecked={checked}
                // onChange={() => setChecked(!checked)}
                style={{
                  width: "fit-content",
                  marginTop: "5px",
                  
                }}
               
              /> */}
              <Checkbox
                checked={formData.disclaimer}
                onClick={() => oncheckedChange()}
                // {...label}
                // defaultChecked
                style={{
                  display: "flex",
                  alignSelf: "baseline",
                  position: "relative",
                  top: "-0.5rem",
                }}
                sx={{
                  color: "#F78F54",

                  "&.Mui-checked": {
                    color: "#F78F54",
                  },
                }}
              />
              <div
                style={{
                  textAlign: "justify",
                  paddingLeft: "5px",
                }}
                className="actualdisclaimer homepageSecondDescription"
              >
                We are in compliance with the provisions of the various Acts,
                Rules, Regulations, Guidelines, Standards applicable to the
                entity from time to time. All information provided by us in the
                application is true, correct and complete and no information
                material to the subject matter of this form has been suppressed
                or concealed. If there is any change in this information or
                compliance status, I will duly inform Startup India within 15
                days on startup.support@investindia.org.in
              </div>
            </div>
            {formData.disclaimer === true
              ? " "
              : error.disclaimer && renderErrorMessage(error.disclaimer)}
          </div>
        );
      default:
        return "unknown step";
      // case 6:
      //   return <div className="startupstepsforms"></div>;

      // default:
      //   return "unknown step";
    }
  };

  // const { autoFetchedData } = props && props.location.state;
  const classes = useStyles();

  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]);
  const [preferredStage, setPreferredStage] = useState([]);
  const defaultFormData = {
    entity_name:
      props.location.state && props.location.state.name
        ? props.location.state.name
        : "",
    dpiit_no:
      props.location.state && props.location.state.dippNumber
        ? props.location.state.dippNumber
        : "",
    sector:
      props.location.state && props.location.state.sectors
        ? props.location.state.sectors[0]
        : "",

    function: servicedata,

    industry:
      props.location.state && props.location.state.industry
        ? props.location.state.industry
        : "NA",
    stage:
      props.location.state && props.location.state.stage
        ? props.location.state.stage
        : "",

    applicant_name:
      props.location.state && props.location.state.applicant_name
        ? // &&
          // props.location.state.applicationStatus === "SUBMITTED"
          props.location.state.applicant_name
        : "",
    current_revenue: "",
    startupwebsite: "",
    whyneedMentorship: "",
    expected_outcome: "",
    preferedsectormentor: [],
    // industrydata: [],
    industrydata: [],
    // props.location.state && props.location.state.industry
    //   ? props.location.state.industry
    //   : "NA",
    // subindustry: [],
    subindustry: [],
    // props.location.state && props.location.state.subindustry
    //   ? props.location.state.subindustry
    //   : "NA",
    // preferedfuncsupport: [],
    // subspecialization: [],
    preferedfuncsupport: [],
    subspecialization: [],
    // props.location.state && props.location.state.preferedfuncsupport
    //   ? props.location.state.subindustry
    //   : "NA",
    // preferredStage: [],
    // subindustry: [],
    // preferedsectormentor: [],

    // preferedfuncsupport: [],
    // currentstage: [],
    currentstage: [],
    // props.location.state && props.location.state.currentstage
    //   ? props.location.state.currentstage
    //   : "NA",
    designation: "",
    uploadResume: null,
    uploadLogo: null,
    uploadLogoFromUrl: null,
    uploadProfileFromUrl: null,
    uploadDocFromUrl: null,
    uploadProfile: null,
    disclaimer: false,
    country: "IN",
    country_name: "India",
    // gender:"",
    email_id:
      props.location.state && props.location.state.email
        ? // &&
          // props.location.state.applicationStatus === "SUBMITTED"
          props.location.state.email
        : "",
    contact_no:
      props.location.state && props.location.state.phone.length > 10
        ? props.location.state.phone
        : "91" + props.location.state.phone,
    // props.location.state && props.location.state.phone
    //   ? props.location.state.phone
    //   : "",
    state: props.location.state.state === "" ? "" : prefilledState,
    // state: [],
    // state:props.location.action === "EditApplication" ? prefilledState : "",

    // state: "",
    state_name:
      props.location.state &&
      props.location.state.state_name &&
      props.location.state.applicationStatus === "SUBMITTED"
        ? // &&
          // props.location.state.applicationStatus === "SUBMITTED"
          props.location.state.state_name
        : "",
    city: props.location.state.city === "" ? "" : prefilledCity,
    // city:
    //   props.location.state && props.location.state.city
    //     ? props.location.state.city
    //     : "",
    AppLindin_url: "",
    startupwebsite: "",
    curret_revenue: "",
    offered_startup: "",
    problem_solved: "",

    // preffered_sector: "",
    // preffered_function: "",
    // current_stage: "",
    startup_video_url: "",
    gender:
      props.location.state &&
      props.location.state.gender &&
      props.location.state.applicationStatus === "SUBMITTED"
        ? prefilledGender
        : "",
  };

  const [formData, setFormData] = useState(defaultFormData);

  const [formPercentageValue, setFormPercentageValue] = useState(0);
  const [formPercentage, setFormPercentage] = useState({
    entityName: {
      value: true,
      weightage: 3.33,
    },
    dpiitNo: {
      value: false,
      weightage: 3.33,
    },
    sectorsInitial: {
      value: false,
      weightage: 3.33,
    },
    industryInitial: {
      value: false,
      weightage: 3.33,
    },
    functionInitial: {
      value: false,
      weightage: 3.33,
    },
    stageInitial: {
      value: false,
      weightage: 3.33,
    },
    applicant_name: {
      value: false,
      weightage: 2.5,
    },
    emailID: {
      value: false,
      weightage: 2.5,
    },
    phoneNumber: {
      value: false,
      weightage: 2.5,
    },
    designation: {
      value: false,
      weightage: 2.5,
    },
    gender: {
      value: false,
      weightage: 2.5,
    },
    country: {
      value: false,
      weightage: 2.5,
    },
    countryState: {
      value: false,
      weightage: 2.5,
    },
    city: {
      value: false,
      weightage: 2.5,
    },
    linkedInURL: {
      value: false,
      weightage: 2,
    },
    startupURL: {
      value: false,
      weightage: 2,
    },
    productURL: {
      value: false,
      weightage: 2,
    },
    startupDoc: {
      value: false,
      weightage: 2,
    },
    current_revenue: {
      value: false,
      weightage: 2,
    },
    coreService: {
      value: false,
      weightage: 5,
    },
    problem_solved: {
      value: false,
      weightage: 5,
    },
    whyneedMentorship: {
      value: false,
      weightage: 5,
    },
    mentorshipOutcome: {
      value: false,
      weightage: 5,
    },
    industry: {
      value: false,
      weightage: 5,
    },
    industryKeywords: {
      value: false,
      weightage: 5,
    },
    function: {
      value: false,
      weightage: 5,
    },
    functionKeyword: {
      value: false,
      weightage: 5,
    },
    stage: {
      value: false,
      weightage: 5,
    },
    termsConfirmation: {
      value: false,
      weightage: 5,
    },
  });
  const generatePercentageData = (params) => {
    let step0output =
      formPercentage.entityName.weightage +
      formPercentage.dpiitNo.weightage +
      formPercentage.sectorsInitial.weightage +
      formPercentage.industryInitial.weightage +
      formPercentage.functionInitial.weightage +
      formPercentage.stageInitial.weightage;

    let step1output =
      formPercentage.emailID.weightage +
      formPercentage.country.weightage +
      (formData?.applicant_name && formData?.applicant_name !== ""
        ? formPercentage.applicant_name.weightage
        : 0) +
      (formData?.contact_no && formData?.contact_no.length === 12
        ? formPercentage.phoneNumber.weightage
        : 0) +
      (formData?.designation && formData?.designation !== ""
        ? formPercentage.designation.weightage
        : 0) +
      (formData?.gender && formData?.gender !== ""
        ? formPercentage.gender.weightage
        : 0) +
      (formData?.state && formData?.state !== ""
        ? formPercentage.countryState.weightage
        : 0) +
      (formData?.city && formData?.city !== ""
        ? formPercentage.designation.weightage
        : 0);

    let step2output =
      (formData?.AppLindin_url && formData?.AppLindin_url !== ""
        ? formPercentage.linkedInURL.weightage
        : 0) +
      (formData?.startupwebsite && formData?.startupwebsite !== ""
        ? formPercentage.startupURL.weightage
        : 0) +
      (formData?.startup_video_url && formData?.startup_video_url !== ""
        ? formPercentage.productURL.weightage
        : 0) +
      +(formData.uploadResume && formData.uploadResume.name
        ? formPercentage.startupDoc.weightage
        : 0) +
      (formData.current_revenue && formData.current_revenue !== ""
        ? formPercentage.current_revenue.weightage
        : 0);
    let step20output =
      formPercentage.linkedInURL.weightage +
      formPercentage.startupURL.weightage +
      formPercentage.productURL.weightage +
      formPercentage.startupDoc.weightage +
      formPercentage.current_revenue.weightage;

    let step3output =
      (formData?.offered_startup && formData?.offered_startup !== ""
        ? formPercentage.coreService.weightage
        : 0) +
      (formData?.problem_solved && formData?.problem_solved !== ""
        ? formPercentage.problem_solved.weightage
        : 0);

    let step4output =
      (formData?.whyneedMentorship && formData?.whyneedMentorship !== ""
        ? formPercentage.whyneedMentorship.weightage
        : 0) +
      (formData?.expected_outcome && formData?.expected_outcome !== ""
        ? formPercentage.mentorshipOutcome.weightage
        : 0);

    let step5output =
      (formData.industrydata && formData.industrydata.length > 0
        ? formPercentage.industry.weightage
        : 0) +
      (formData.subindustry && formData.subindustry.length > 0
        ? formPercentage.industryKeywords.weightage
        : 0) +
      (formData.preferedfuncsupport && formData.preferedfuncsupport.length > 0
        ? formPercentage.function.weightage
        : 0) +
      (formData.subspecialization && formData.subspecialization.length > 0
        ? formPercentage.functionKeyword.weightage
        : 0) +
      (formData.currentstage && formData.currentstage.length > 0
        ? formPercentage.stage.weightage
        : 0) +
      (formData?.disclaimer && formData?.disclaimer !== ""
        ? formPercentage.termsConfirmation.weightage
        : 0) +
      ((formData.subindustry && formData.subindustry.length == 10) ||
      (formData.subspecialization && formData.subspecialization.length == 10)
        ? 5
        : 0);
    if (activeStep == 0) {
      setFormPercentageValue(step0output);
    }
    if (activeStep == 1) {
      setFormPercentageValue(step0output + step1output);
    }
    if (activeStep == 2) {
      setFormPercentageValue(step0output + step1output + step2output);
    }
    if (activeStep == 3) {
      setFormPercentageValue(
        step0output + step1output + step20output + step3output
      );
    }
    if (activeStep == 4) {
      setFormPercentageValue(
        step0output + step1output + step20output + step3output + step4output
      );
    }
    if (activeStep == 5) {
      setFormPercentageValue(
        step0output +
          step1output +
          step20output +
          step3output +
          step4output +
          step5output
      );
    }
  };

  useEffect(() => {
    generatePercentageData();
  }, [activeStep]);
  useEffect(() => {
    generatePercentageData();
  }, [formData]);

  const [fileName, setFileName] = useState("");

  const steps = getSteps();
  // alert(formListFromService.length)
  // const steps=formListFromService;
  // let steps;
  const isStepOptional = (step) => {
    return step === 10 || step === 20;
  };
  const newStateOptionfunc = (state) => {
    const newCityArray = [];
    City.getCitiesOfState("IN", state).map((item) => {
      const newObject = {
        value: item.name,
        label: item.name,
      };

      newCityArray.push(newObject);
      setNewCityOptions(newCityArray);
    });
  };
  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");

      let data = JSON.parse(localStorage.getItem("SavedLoggedInData"));
      // setData(JSON.parse(value))
      if (data?.image === null) setProfileExistingImg(hashImage);
      else setProfileExistingImg(data.image);
    } catch (error) {}
  }, []);
  // useEffect(() => {
  //   setFormListFromService(props.formlist);
  //   // props.formlist.map((step, index) => {
  //   //
  //   //  steps=formListFromService;
  //   // })
  // }, []);
  useEffect(() => {
    // setStageList(formData?.currentstage);
    // setSpecializationList(formData?.subspecialization);
    // setFunctionList(formData?.preferedfuncsupport);
    // setIndustrySectorList(formData?.subindustry);
    // setIndustryList(formData?.industrydata);

    // Country.getAllCountries().map((item) => {
    //   const newObject = {
    //     value: item.isoCode,
    //     label: item.name,
    //   };

    //   newCountryArray.push(newObject);

    //   // setNewCountryOptions(newCountryArray);
    // });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
    const newCityArray = [];
    City.getCitiesOfState(
      "IN",
      localStorage.getItem("selectedNewStateexist")
    ).map((item) => {
      const newObject = {
        value: item.name,
        label: item.name,
      };

      newCityArray.push(newObject);
      setNewCityOptions(newCityArray);
    });
  }, []);

  const isStepSkipped = (step) => {
    return skippedSteps.includes(step);
  };

  const handleNext = () => {
    const loginDataJson = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // alert(loginDataJson.applicationStatus)

    if (activeStep === 0) {
      // if (!validateStep1Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {

      setSubmitFormData(formData);

      setActiveStep(activeStep + 1);
      if (applicationStatusValue === "SUBMITTED") {
      } else {
        localStorage.setItem("selectedNewStateexist", formData?.state?.value);

        addDraftData(formData, "nextdraftbutton", props.fromModule);
      }
      // }
    } else if (activeStep === 1) {
      if (!validateStep2Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setSubmitFormData(formData);

        setActiveStep(activeStep + 1);
        if (applicationStatusValue === "SUBMITTED") {
          // alert("if")
        } else {
          // alert("else")
          localStorage.setItem("selectedNewStateexist", formData?.state?.value);

          addDraftData(formData, "nextdraftbutton", props.fromModule);
        }
      }
    } else if (activeStep === 2) {
      if (!validateStep3Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        if (applicationStatusValue === "SUBMITTED") {
        } else {
          setSubmitFormData(formData);
          localStorage.setItem("selectedNewStateexist", formData?.state?.value);

          addDraftData(formData, "nextdraftbutton", props.fromModule);
        }
      }
    } else if (activeStep === 3) {
      if (!validateStep4Input()) {
      } else {
        setActiveStep(activeStep + 1);
        if (applicationStatusValue === "SUBMITTED") {
        } else {
          setSubmitFormData(formData);
          localStorage.setItem("selectedNewStateexist", formData?.state?.value);

          addDraftData(formData, "nextdraftbutton", props.fromModule);
        }
      }
    } else if (activeStep === 4) {
      if (!validateStep5Input()) {
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        if (applicationStatusValue === "SUBMITTED") {
        } else {
          setSubmitFormData(formData);
          localStorage.setItem("selectedNewStateexist", formData?.state?.value);

          addDraftData(formData, "nextdraftbutton", props.fromModule);
        }
      }
    }
    //  else if (activeStep === 5) {
    //   if (!validateStep6Input()) {
    //     setHasInvalidSubmitOccurred(true);
    //   } else {
    //     setActiveStep(activeStep + 1);
    //   }
    // }
    else if (activeStep === 5) {
      if (!validateStep6Input()) {
        // alert("test");
        setHasInvalidSubmitOccurred(true);
      } else {
        // alert("else");

        // setHasInvalidSubmitOccurred(false);
        // setActiveStep(activeStep + 1);

        setActiveStep(activeStep + 1);
        // addFormData(formData);
        localStorage.setItem("selectedNewStateexist", formData?.state?.value);

        addFormData(formData, props.fromModule);
        setTimeout(() => {
          // localStorage.setItem("selectedNewStateexist", formData?.state?.value);
          setActiveStep(activeStep + 1);

          // addFormData(formData);
        }, 200);
      }
    }

    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  };

  const handleDraft = () => {
    if (activeStep === 0) {
      // if (!validateStep1Input()) {
      //   // setHasInvalidSubmitOccurred(true);
      //   addDraftData(formData);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    } else if (activeStep === 1) {
      // if (!validateStep2Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    } else if (activeStep === 2) {
      // if (!validateStep3Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    } else if (activeStep === 3) {
      // if (!validateStep4Input()) {
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    } else if (activeStep === 4) {
      // if (!validateStep5Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setActiveStep(activeStep + 1);
      //   addDraftData(formData);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    }
    //  else if (activeStep === 5) {
    //   if (!validateStep6Input()) {
    //     setHasInvalidSubmitOccurred(true);
    //   } else {
    //     setActiveStep(activeStep + 1);
    //   }
    // }
    else if (activeStep === 5) {
      // if (!validateStep6Input()) {
      //   setHasInvalidSubmitOccurred(true);
      // } else {
      //   // setHasInvalidSubmitOccurred(false);
      //   // setActiveStep(activeStep + 1);

      //   // setActiveStep(activeStep + 1);
      //   setTimeout(() => {

      //     addDraftData(formData);
      //   }, 1500);
      // }
      localStorage.setItem("selectedNewStateexist", formData?.state?.value);

      addDraftData(formData, "savedraftbutton", props.fromModule);
    }

    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
    // setSubmitFormData(formData);
  };

  const handleBack = () => {
    // if(activeStep=== 0){

    // }
    setActiveStep(activeStep - 1);
  };

  const addFormData = (submitData, fromModule) => {
    const newformData = new FormData();
    const industryArray = [];

    const specialityArray = [];
    const subspecialityArray = [];
    const preferedStageArray = [];
    const preferedsectormentor = [];
    const preferedfunctionsupport = [];
    const preferredStageArray = [];

    const industryDataArray = [];
    const subindustryArray = [];
    // const currentstageArray = [];

    submitData?.industrydata.map((stage) => {
      industryDataArray.push(stage.value);
    });

    submitData?.subindustry.map((stage) => {
      subindustryArray.push(stage.value);
    });

    submitData?.preferedfuncsupport.map((stage) => {
      preferedfunctionsupport.push(stage.value);
    });

    submitData?.subspecialization.map((stage) => {
      subspecialityArray.push(stage.value);
    });

    // submitData?.currentstage.map((stage) => {
    //   currentstageArray.push(stage.value);
    // });

    // submitData?.preferedsectormentor.map((stage) => {
    //   preferedsectormentor.push(stage.value);
    // });

    submitData?.currentstage.map((stage) => {
      preferredStageArray.push(stage.value);
    });

    const startupapplication = {
      id: userId,
      appLindin_url: submitData.AppLindin_url,
      applicant_name: submitData.applicant_name,
      city: submitData.city.value,
      contact_no: submitData.contact_no,
      gender: submitData.gender.value,
      // gender: submitData.gender,
      country: submitData.country,
      country_name: submitData.country_name,
      // current_stage: submitData?.stage,
      curret_revenue: submitData.current_revenue,
      designation: submitData.designation,
      dpiit_no: submitData.dpiit_no,
      email_id: submitData.email_id,
      entity_name: submitData.entity_name,
      expected_outcome: submitData.expected_outcome,
      industry: submitData.industry,
      industrydata: industryDataArray,
      subindustry: subindustryArray,
      offered_startup: submitData.offered_startup,
      preffered_function: preferedfunctionsupport,
      subspecialization: subspecialityArray,
      preffered_stages: preferredStageArray,
      // currentstage: currentstageArray,
      // preffered_sector: preferedsectormentor,
      // preffered_stages: preferredStageArray,
      problem_solved: submitData.problem_solved,
      sector: submitData.sector,
      stage: submitData.stage,
      services: submitData.function,
      startup_video_url: submitData.startup_video_url,
      startupwebsite: submitData.startupwebsite,
      state: submitData.state.value,
      state_name: submitData.state_name,
      whyneedMentorship: submitData.whyneedMentorship,
    };

    newformData.append("application", JSON.stringify(startupapplication));

    newformData.append("upload_logo", submitData.uploadLogo);

    newformData.append("upload_document", submitData.uploadResume);
    newformData.append("upload_profile", submitData.uploadProfile);

    registerStartUp(newformData, fromModule).then((res) => {
      if (res) {
        // if (res) {
        //   history.push({
        //     pathname: "/",
        //   });

        //   // onCloseBothModal();
        //   onClose();
        // }
        if (res) {
          // localStorage.removeItem("SavedLoggedInData");
          // localStorage.removeItem("loggedIn");
          // history.push({
          //   pathname: "/",
          // });
          if (
            (fromModule && fromModule === "completeApplication") ||
            (fromModule && fromModule === "editProfile")
          ) {
            history.goBack();
          } else {
            let value = localStorage.getItem("SavedLoggedInData");
            let LoginFormData = JSON.parse(value);
            history.push({
              pathname: "/startup-dashboard",
              state: LoginFormData,
            });
          }
        }
      }
    });
  };

  const addDraftData = (submitData, buttontype) => {
    const newformData = new FormData();
    const industryArray = [];

    const specialityArray = [];
    const subspecialityArray = [];
    const preferedStageArray = [];
    const preferedsectormentor = [];
    const preferedfunctionsupport = [];
    const preferredStageArray = [];

    const industryDataArray = [];
    const subindustryArray = [];
    const currentstageArray = [];

    try {
      submitData &&
        submitData?.industrydata.map((stage) => {
          industryDataArray.push(stage.value);
        });
      submitData &&
        submitData?.subindustry.map((stage) => {
          subindustryArray.push(stage.value);
        });
      submitData &&
        submitData?.preferedfuncsupport.map((stage) => {
          preferedfunctionsupport.push(stage.value);
        });
      submitData &&
        submitData?.subspecialization.map((stage) => {
          subspecialityArray.push(stage.value);
        });

      submitData &&
        submitData?.currentstage.map((stage) => {
          preferredStageArray.push(stage.value);
        });
    } catch (error) {}

    // submitData &&
    //   submitData?.currentstage &&
    //   submitData?.currentstage.map((stage) => {
    //     currentstageArray.push(stage.value);
    //   });

    // submitData?.preferedsectormentor.map((stage) => {
    //   preferedsectormentor.push(stage.value);
    // });

    // submitData?.preferredStage.map((stage) => {
    //   preferredStageArray.push(stage.value);
    // });

    const startupapplication = {
      id: userId,
      appLindin_url: submitData.AppLindin_url,
      applicant_name: submitData.applicant_name,
      city: submitData.city.value,
      contact_no: submitData.contact_no,
      gender: submitData.gender?.value,
      // gender: submitData.gender,
      country: submitData.country,
      country_name: submitData.country_name,
      // current_stage: submitData?.stage,
      curret_revenue: submitData.current_revenue,
      designation: submitData.designation,
      dpiit_no: submitData.dpiit_no,
      email_id: submitData.email_id,
      entity_name: submitData.entity_name,
      expected_outcome: submitData.expected_outcome,
      industry: submitData.industry,
      industrydata: industryDataArray,
      subindustry: subindustryArray,
      offered_startup: submitData.offered_startup,
      preffered_function: preferedfunctionsupport,
      subspecialization: subspecialityArray,
      preffered_stages: preferredStageArray,
      services: submitData.function,
      // preffered_sector: preferedsectormentor,
      // preffered_stages: preferredStageArray,
      problem_solved: submitData.problem_solved,
      sector: submitData.sector,
      stage: submitData.stage,
      startup_video_url: submitData.startup_video_url,
      startupwebsite: submitData.startupwebsite,
      state: submitData.state.value,
      state_name: submitData.state_name,
      whyneedMentorship: submitData.whyneedMentorship,
    };

    newformData.append("application", JSON.stringify(startupapplication));

    newformData.append("upload_logo", submitData.uploadLogo);

    newformData.append("upload_document", submitData.uploadResume);
    newformData.append("upload_profile", submitData.uploadProfile);

    savedraftStartUp(newformData, buttontype, props.fromModule).then((res) => {
      if (res) {
        // if (res) {
        //   history.push({
        //     pathname: "/",
        //   });

        //   // onCloseBothModal();
        //   onClose();
        // }
        if (res && buttontype === "savedraftbutton") {
          // let value = localStorage.getItem("SavedLoggedInData");
          // let LoginData = JSON.parse(value);
          if (props.fromModule == "completeApplication") {
            // history.goBack();
          } else {
            // localStorage.removeItem("SavedLoggedInData");
            // localStorage.removeItem("loggedIn");
            // history.push({
            //   pathname: "/",
            // });
          }
        }
      }
    });
  };

  // const steps = getSteps();
  const allStepsData =
    // props.formlist &&
    // props.formlist.list &&
    // Array.isArray(props?.formlist.list) &&
    // // props?.formlist?.list.length > 0 &&
    // props.formlist.list

    steps.map((step, index) => {
      // alert('activeStep'+activeStep)
      // alert(index)
      // .map(step => {
      return (
        <li
          className={
            activeStep === index
              ? "active"
              : index <= activeStep
              ? "active"
              : "lastStep"
          }
          key={step.step}
        >
          {/* <span className="count">
            <span>{index + 1}</span>
          </span> */}
          <span className="count">
            {activeStep == index ? <>{Math.round(formPercentageValue)}%</> : ""}

            {/* {index === 0 ? (
              <span>
                {" "}
                {activeStep == index ? (
                  <>0%</>
                ) : activeStep === 1 ? (
                  <>20%</>
                ) : (
                  ""
                )}
              </span>
            ) : index !== 7 ? (
              <span>
                {activeStep === index + 1
                  ? Math.round(((index + 1) / steps.length) * 100) + "%"
                  : ""}
              </span>
            ) : (
              <span style={{ width: "80%" }}>100%</span>
            )} */}
          </span>
          <div className="text">
            <p className="homepageSecondDescription">{step}</p>
            {/* {step} */}
          </div>
        </li>
      );
    });
  const handleSkip = () => {
    if (!isStepSkipped(activeStep)) {
      setSkippedSteps([...skippedSteps, activeStep]);
    }
    setActiveStep(activeStep + 1);
  };

  return (
    <div>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        className={classes.root}
      >
        {
          <Step className={classes.rootSteps}>
            <div className="row steps">
              <div className="col-12 startupStepperTop">
                <ul>{allStepsData}</ul>
              </div>
            </div>
          </Step>
        }
      </Stepper>

      {activeStep === steps.length ? (
        <Typography variant="h3" style={{ fontSize: "20px" }} align="center">
          Processing...Please Wait
        </Typography>
      ) : (
        <>
          <div
            className="startupStepperForm"
            // style={{
            //   height: "100%",
            //   width: "100%",
            //   // backgroundColor:"#000",
            //   // backgroundImage: `url(${formbg})`,
            //   display: "flex",
            //   justifyContent: "center",
            //   alignItems: "center",
            // }}
          >
            <div style={{ width: "50%" }}>
              <form>
                {getStepContent(
                  activeStep,
                  classes
                  // autoFetchedData
                  // props?.formlist.list && props?.formlist.list[activeStep]
                )}
              </form>

              {activeStep === 0 ? (
                ""
              ) : (
                <a
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className="brd-btn d-inline-block newbtnbottom"
                  style={{
                    backgroundColor: "#f4f4f4",
                    // backgroundColor: "#f4f4f4",
                    color: "#3AC2D7",
                    // color: "#3AC2D7",
                    width: "9em",
                    marginTop: "20px",
                    marginRight: "8px",
                    border: "1px solid #00000040",
                    borderRadius: "5px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                    cursor: "pointer",
                    zIndex: 0,
                  }}
                  // title=""
                >
                  <i className="fa fa-arrow-left"></i> &nbsp;
                  {activeStep === 0 ? "Cancel" : "Previous"}
                </a>
              )}

              <a
                onClick={handleNext}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  // backgroundColor: "#f4f4f4",
                  color: "#3AC2D7",
                  // color: "#3AC2D7",
                  width: "9em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border: "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  cursor: "pointer",
                  zIndex: 0,
                }}
                // title=""
              >
                {steps && activeStep === steps.length - 1 ? "Submit" : "Next"}{" "}
                &nbsp;
                <i className="fa fa-arrow-right"></i>
              </a>
              {applicationStatusValue &&
              applicationStatusValue === "SUBMITTED" ? (
                ""
              ) : (
                <a
                  // disabled={activeStep === 0}
                  // onClick={handleBack}
                  onClick={handleDraft}
                  className="brd-btn d-inline-block newbtnbottom"
                  style={{
                    backgroundColor: "#f4f4f4",
                    // backgroundColor: "#f4f4f4",
                    color: "#3AC2D7",
                    // color: "#3AC2D7",
                    width: "9em",
                    marginTop: "20px",
                    marginRight: "8px",
                    border: "1px solid #00000040",
                    borderRadius: "5px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                    cursor: "pointer",
                    zIndex: 0,
                  }}
                  // title=""
                >
                  {/* <i className="fa fa-arrow-left"></i> &nbsp; */}
                  {"Save as draft"}
                </a>
              )}
            </div>
          </div>
        </>
      )}
      <SubmitForm
        // activityFellowId={activityFellowId}
        isOpen={showSubmitCohort}
        className={"form-submit-modal"}
        onClose={clickOnClose}
        submitData={submitFormData}
        formName={"startup-form"}
        // onCloseafterdelete={onCloseafterdelete}
        // requirementId={requirementId}
        // currentUserId={currentUserId}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    applicationData: state.GetMentorFormReducer.getViewApplicationData.data,
  };
};
export default connect(mapStateToProps, {
  registerStartUp,
  savedraftStartUp,
  getPredefineOptionsList,
  getViewApplicationData,
})(withRouter(StartupSteps));

// export default StartupSteps;
